import { type Inspiration } from '$/services/usecases/inspirations/mapper/inspiration.schema';
import { type MaterialType } from '$/services/usecases/materials/mapper/materials';

const facadeCategories = [
  'one_family_house',
  'two_family_house',
  'apartment_building',
  'town_house',
  'half_timbered_house',
  'historical_facade',
];

export const config = {
  veeuzeCnf: 'spectrum-default',
  materials: {
    homepagePreviewIds: [
      // Lavendel 105
      'Y29sb3JfdGludDs7Y2FwYXJvbDs7M2Qtc3lzdGVtLXBsdXM7O0xhdmVuZGVsIDEwNQ_equal__equal_',
      // MPLus Pro Vlies 2027
      'd2FsbF90ZXh0dXJlOzttcGx1cy13YW5kOztwcm8tdmxpZXMtMjAyNzs7TVBsdXMgUHJvIFZsaWVzIDIwMjcgVGFwZXRlIDU5NzU2',
      // Eiche Dunkel
      'Zmxvb3JfdGV4dHVyZTs7bXBsdXMtYm9kZW47O2F2YW50aS0yMDI2OztEMTU4MSB8IFJCMTU4MC05OTk4OSBFaWNoZSBEdW5rZWw_equal_',
      // Mäander Fuge Anthrazit
      'ZmFjYWRlX3RleHR1cmU7O21lbGRvcmZlcjs7bmF0dXJlLWVsZW1lbnQ7O03DpGFuZGVyIEZ1Z2UgQW50aHJheml0',
    ],
  },
  filter: {
    colors: new Map([
      ['white', '#FFFFFF'],
      ['black', '#000000'],
      ['yellow', '#FFE600'],
      ['orange', '#FF9900'],
      ['red', '#FF0000'],
      ['pink', '#FF00F5'],
      ['purple', '#8F00FF'],
      ['blue', '#0085FF'],
      ['green', '#00CC52'],
      ['beige', '#C7BEB3'],
      ['brown', '#804500'],
      ['grey', '#808080'],
    ]),
  },
  inspirations: {
    getForMaterialModal: (type: MaterialType, inspirations: Inspiration[]) =>
      inspirations
        .filter(
          ({ category, name }) =>
            !name.includes('DesignGuide') &&
            (type === 'facade_texture'
              ? facadeCategories.includes(category)
              : !facadeCategories.includes(category)),
        )
        .slice(0, 3)
        .map(({ id, thumbnail }, index) => ({
          id,
          thumbnail,
          label: `Inspiration ${index + 1}`,
        })),
  },
};
